export const FEET = [
  {
    name: 'Primordial Boots',
    slot: 'feet',
    regions: ['Asgarnia'],
    requirements: [{ skill: 'Defence', level: 75 }],
    bonuses: {
      attack:  { stab: 2, slash: 2, crush: 2, magic: -4, ranged: -1 },
      defence: { stab: 22, slash: 22, crush: 22, magic: 0, ranged: 0 },
      other:   { meleeStrength: 5, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Avernic Treads',
    slot: 'feet',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Defence', level: 80 }],
    bonuses: {
      attack:  { stab: 5, slash: 5, crush: 5, magic: 11, ranged: 15 },
      defence: { stab: 21, slash: 25, crush: 25, magic: 10, ranged: 10 },
      other:   { meleeStrength: 4, rangedStrength: 2, magicDamage: 1, prayer: 0 },
    },
  },
    {
    name: 'Avernic Treads (Max)',
    slot: 'feet',
    regions: ['Varlamore', 'Asgarnia'],
    requireAllRegions: true,
    requirements: [{ skill: 'Defence', level: 80 }],
    bonuses: {
      attack:  { stab: 5, slash: 5, crush: 5, magic: 11, ranged: 15 },
      defence: { stab: 21, slash: 25, crush: 25, magic: 10, ranged: 10 },
      other:   { meleeStrength: 6, rangedStrength: 3, magicDamage: 2, prayer: 0 },
    },
  },
  {
    name: 'Pegasian Boots',
    slot: 'feet',
    regions: ['Asgarnia'],
    requirements: [{ skill: 'Ranged', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -12, ranged: 12 },
      defence: { stab: 5, slash: 5, crush: 5, magic: 5, ranged: 5 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Eternal Boots',
    slot: 'feet',
    regions: ['Asgarnia'],
    requirements: [{ skill: 'Magic', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 8, ranged: 0 },
      defence: { stab: 5, slash: 5, crush: 5, magic: 8, ranged: 5 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 1, prayer: 0 },
    },
  },
  {
    name: 'Echo Boots',
    slot: 'feet',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Defence', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -3, ranged: -1 },
      defence: { stab: 32, slash: 32, crush: 32, magic: -3, ranged: 24 },
      other:   { meleeStrength: 3, rangedStrength: 0, magicDamage: 0, prayer: 4 },
    },
  },
  {
    name: 'Guardian Boots',
    slot: 'feet',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -3, ranged: -1 },
      defence: { stab: 32, slash: 32, crush: 32, magic: -3, ranged: 24 },
      other:   { meleeStrength: 3, rangedStrength: 0, magicDamage: 0, prayer: 2 },
    },
  },
  {
    name: 'Aranea Boots',
    slot: 'feet',
    regions: ['Morytania'],
    requirements: [{ skill: 'Magic', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 5, ranged: 6 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 4, rangedStrength: 0, magicDamage: 0, prayer: 1 },
    },
  },
  {
    name: 'Dragon Boots',
    slot: 'feet',
    regions: ['Asgarnia', 'Wilderness'],
    requirements: [{ skill: 'Defence', level: 60 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -3, ranged: -1 },
      defence: { stab: 16, slash: 17, crush: 18, magic: 0, ranged: 0 },
      other:   { meleeStrength: 4, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Bandos Boots',
    slot: 'feet',
    regions: ['Asgarnia'],
    requirements: [{ skill: 'Defence', level: 65 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -5, ranged: -3 },
      defence: { stab: 17, slash: 18, crush: 19, magic: 0, ranged: 15 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 1 },
    },
  },
  {
    name: 'Granite Boots',
    slot: 'feet',
    regions: [],
    requirements: [{ skill: 'Defence', level: 50 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -3, ranged: -1 },
      defence: { stab: 15, slash: 16, crush: 17, magic: 0, ranged: 8 },
      other:   { meleeStrength: 3, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Devout Boots',
    slot: 'feet',
    regions: ['Morytania'],
    requirements: [{ skill: 'Prayer', level: 60 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 5 },
    },
  },
  {
    name: 'Boots of Brimstone',
    slot: 'feet',
    regions: ['Kourend'],
    requirements: [{ skill: 'Slayer', level: 44 }, { skill: 'Magic', level: 44 }, { skill: 'Defence', level: 44 }],
    bonuses: {
      attack:  { stab: 3, slash: 0, crush: 0, magic: 3, ranged: 5 },
      defence: { stab: 10, slash: 10, crush: 10, magic: 5, ranged: 5 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Infinity Boots',
    slot: 'feet',
    regions: [],
    requirements: [{ skill: 'Magic', level: 50 }, { skill: 'Defence', level: 25 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 5, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 5, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Wizard Boots',
    slot: 'feet',
    regions: [],
    requirements: [{ skill: 'Magic', level: 20 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 4, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 4, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Snakeskin Boots',
    slot: 'feet',
    regions: [],
    requirements: [{ skill: 'Ranged', level: 30 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -10, ranged: 3 },
      defence: { stab: 1, slash: 1, crush: 2, magic: 1, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Rune Boots',
    slot: 'feet',
    regions: [],
    requirements: [{ skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -3, ranged: -1 },
      defence: { stab: 12, slash: 13, crush: 14, magic: 0, ranged: 0 },
      other:   { meleeStrength: 2, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
];
